export default __webpack_public_path__ + "95e47f37d3b6736db4412e5e01efffa9.png";